import { importWhenVisible } from '@studiometa/js-toolkit';
import Panel from '../Panel.js';
import Items from './Items.js';

/**
 * Cart component
 * @see https://liquid-ajax-cart.js.org/v2/
 */
export default class Cart extends Panel {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Cart',
    refs: ['finalPrice', ...Panel.config.refs],
    components: {
      Items,
      CrossSell: (app) =>
        importWhenVisible(() => import('../../Sections/Slider/index.js'), 'CrossSell', app),
    },
  };

  /**
   * mounted
   */
  mounted() {
    document.addEventListener('liquid-ajax-cart:request-end', (event) => {
      const { requestState } = event.detail;

      if (requestState.requestType === 'add' && requestState.responseData?.ok) {
        const subId = localStorage.getItem('kwanko_subid');
        if (subId && !requestState.responseData?.body?.attributes?.kwanko_subid) {
          window.liquidAjaxCart?.update({ attributes: { kwanko_subid: subId } });
        }

        this.openPanel();
      }

      if (!requestState.responseData?.ok) {
        this.$root.Toaster.addToast(requestState.responseData?.body?.message);
      }

      this.$root.$update();
    });
  }

  /**
   *
   */
  openPanel() {
    setTimeout(() => {
      window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: window.datalayer_data.currency,
          value: this.$refs.finalPrice
            ? Number.parseFloat(this.$refs.finalPrice.dataset.formatted)
            : undefined,
          items: this.datalayer_items,
        },
        _clear: true,
      });
    }, 500);
    super.openPanel();
  }

  /**
   * @returns {object} datalayer of items
   */
  get datalayer_items() {
    return this.$children.Items.map((element) => {
      return { ...element.datalayer };
    });
  }
}
